import React from 'react'

import { IStatisticsStateData } from './statistics.interface'

type StatisticsContextProps = {
  received: IStatisticsStateData
  setReceived: (data: IStatisticsStateData) => void
  collectiveStatistics: any
  setCollectiveStatistics: (data: any) => void
  modifiedStatistics: string[]
  setModifiedStatistics: (data: string[]) => void
}

const StatisticsContext = React.createContext<StatisticsContextProps>({
  received: {
    data: [],
    imported: false,
  },
  setReceived: () => {},
  modifiedStatistics: [],
  setModifiedStatistics: () => {},
  collectiveStatistics: {},
  setCollectiveStatistics: () => {},
})

export const StatisticsProvider = StatisticsContext.Provider
export const StatisticsConsumer = StatisticsContext.Consumer
export default StatisticsContext
